<!-- 
	This is the sign in page, it uses the dashboard layout in: 
	"./layouts/Default.vue" .
 -->

<template>
	<div class="sign-in">
		<a-row type="flex" :gutter="[24,24]" justify="space-around" align="middle">
			<!-- Sign In Form Column -->
			<a-col :span="24" :md="12" :lg="{span: 12, offset: 4}" :xl="{span: 6, offset: 4}" class="col-form">
				<h1 class="mb-15">{{ $t('login_1') }}</h1>
				<h5 class="font-regular text-muted">{{ $t('login_2') }}</h5>

				<!-- Sign In Form -->
				<a-form
					id="components-form-demo-normal-login"
					:form="form"
					class="login-form"
					@submit="handleSubmit"
					:hideRequiredMark="true"
				>
					<a-form-item class="mb-10" :label="$t('login_3') + ' / ' + $t('mobile')" :colon="false">
						<a-input 
						v-decorator="[
						'email',
						{ rules: [{ required: true, message: $t('login_4') }] },
						]" :placeholder="$t('login_3')" />
					</a-form-item>
					<a-form-item class="mb-5" :label="$t('login_5')" :colon="false">
						<a-input
						v-decorator="[
						'password',
						{ rules: [{ required: true, message: $t('login_6') }] },
						]" type="password" :placeholder="$t('login_5')" />
					</a-form-item>
					<!-- <a-form-item class="mb-10">
    					<a-switch v-model="rememberMe" /> Remember Me
					</a-form-item> -->
					<a-form-item>
						<a-button type="primary" block html-type="submit" class="login-form-button" :loading="loginLoading">
							{{ $t('login_7') }}
						</a-button>
					</a-form-item>
				</a-form>
				<!-- / Sign In Form -->
                

				<p class="font-semibold text-muted">{{ $t('login_8') }} <router-link to="/register" class="font-bold text-dark">{{ $t('login_9') }}</router-link></p>
                <p class="font-semibold text-muted">{{ $t('login_10') }} <router-link to="/password" class="font-bold text-dark">{{ $t('login_11') }}</router-link></p>
                
                <div id="googleLoginDiv" style="text-align:center; margin:10px 110px 0; "></div>
            </a-col>
			<!-- / Sign In Form Column -->

			<!-- Sign In Image Column -->
			<a-col :span="24" :md="8" :lg="8" :xl="8" class="col-img">
				<img :src="$STATIC_URL + 'img-signin.png'" alt="">
			</a-col>
			<!-- Sign In Image Column -->

		</a-row>
		
	</div>
</template>

<script>

	export default ({
		data() {
			return {
				// Binded model property for "Sign In Form" switch button for "Remember Me" .
				rememberMe: true,
                loginLoading: false,
			}
		},
		beforeCreate() {
			// Creates the form and adds to it component's "form" property.
			this.form = this.$form.createForm(this, { name: 'normal_login' });
		},
        created() {
            // === 加载 Google 登录 SDK ===
            const script = document.createElement('script');
            script.src = "https://accounts.google.com/gsi/client";
            script.async = true;
            script.defer = true;
            script.onload = () => {
                google.accounts.id.initialize({
                    client_id: "872834967320-5fdiahaj6aac0alclrdt8ajj2i9ht2pk.apps.googleusercontent.com",
                    callback: this.handleGoogleLogin
                });
                google.accounts.id.renderButton(
                    document.getElementById("googleLoginDiv"),
                    { theme: "outline", size: "large", shape: "rectangular", logo_alignment: "center",locale:"en-Us" }
                );
            };
            document.head.appendChild(script);
        },
		methods: {
            handleGoogleLogin(response) {
                console.log("Google 登录返回 token：", response.credential);
                // 发给后端验证
                let params = {
                    token: response.credential,
                };
                this.$HTTP.post('/member/index/google_login', params).then(res => {
                    if (res.data.sts == 1) {
                        this.$store.dispatch('getInfo');
                        this.$APP_MANAGE.setLoginInfo(res.data.data.token);
                        this.$message.success({content: res.data.msg, duration: 1}).then(() => {
                            this.$router.replace('/user/info');
                        });
                    } else {
                        this.$message.error(res.data.msg);
                    }
                })
            },
			// Handles input validation after submission.
			handleSubmit(e) {
				e.preventDefault();
				this.form.validateFields((err, values) => {
					if ( !err ) {
                        let params = {
                            type: 1,
                            member_email: values.email,
                            member_passwd: values.password
                        }
                        this.loginLoading = true;
                        this.$HTTP.post('/member/index/login_check', params).then(res => {
                            this.loginLoading = false;
                            if (res.data.sts == 1) {
                                this.$store.dispatch('getInfo');
                                this.$APP_MANAGE.setLoginInfo(res.data.data);
                                this.$message.success({content: res.data.msg, duration: 1}).then(() => {
                                    this.$router.replace('/user/info');
                                });
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        })
					}
				});
			},
		},
	})

</script>

<style lang="scss" scoped>
	body {
		background-color: #ffffff;
	}

    .sign-in {
        padding-top: 85px;
    }
</style>